export default class Topic {

    /**
     * @param id: string
     * @param title: string
     * @param questions: Question[]
     */
    constructor(
        id,
        title,
        questions
    ) {
        this.id = id;
        this.title = title;
        this.questions = questions;
    }
}